(function () {
	if (!window.PVARCH || !PVARCH.ajaxUrl) {
		console.warn("[views-archive] Нет PVARCH или ajaxUrl");
		return;
	}
	function getCards() {
		return Array.from(document.querySelectorAll("[data-post-id]"));
	}

	function updateViews() {
		var cards = getCards();
		if (!cards.length) {
			console.warn(
				"[views-archive] Не найдено ни одного элемента с [data-post-id]"
			);
			return;
		}
		var ids = [];
		var map = {};

		cards.forEach(function (card) {
			var id = card.getAttribute("data-post-id");
			if (!id) return;
			if (!map[id]) {
				map[id] = [];
				ids.push(id);
			}
			map[id].push(card);
		});
		if (!ids.length) {
			console.warn(
				"[views-archive] Нашли карточки, но у них пустой data-post-id"
			);
			return;
		}

		var fd = new FormData();
		fd.append("action", "pv_get_views");
		ids.forEach(function (id) {
			fd.append("ids[]", id);
		});

		fetch(PVARCH.ajaxUrl, {
			method: "POST",
			body: fd,
			credentials: "same-origin",
		})
			.then(function (r) {
				return r.json();
			})
			.then(function (d) {
				if (!d || !d.success || !d.data || !d.data.items) {
					console.warn(
						"[views-archive] Пустой или неуспешный ответ",
						d
					);
					return;
				}
				var items = d.data.items;
				Object.keys(items).forEach(function (id) {
					var val = String(items[id]);
					(map[id] || []).forEach(function (card) {
						var el = card.querySelector(".js-views");
						if (el) el.textContent = val;
					});
				});
			})
			.catch(function (e) {
				console.error("[views-archive] fetch error", e);
			});
	}

	if (document.readyState === "loading")
		document.addEventListener("DOMContentLoaded", updateViews);
	else updateViews();

	window.addEventListener("pageshow", function (e) {
		if (e.persisted) updateViews();
	});
})();
